import React, { useMemo } from "react";
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import NotAvailable from 'components/common/NotAvailable'
import Loader from 'components/general/Loader';
import Label from "components/general/Label"
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import MirsTable from "components/general/table/Table";
import { getCommunications } from "data/Querys";
import SportCode from "components/common/SportCode";
import Noc from "components/presentation/Noc"
import Moment from 'react-moment';
import { Stack } from "react-bootstrap";

const HearingSchedule = () => {
  const globalProps = useSelector(getGlobalProps)
  const { mirs_competition, mirs_discipline } = useUrlFriendlyToParameters()
    
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['comms', mirs_competition, mirs_discipline],
      queryFn: getCommunications,
      refetchInterval: 10000,
      staleTime: 10000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //onError: (error) =>console.error(`Something went wrong: ${error.message}`),
    }
  )  


  const tableColumns = useMemo(() =>
  [
    {
      id: "date",
      Header: <Label data="HeaderDate"/>,
      accessor: "date",
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        let val = row?.date
        return (
          <Moment tz={globalProps.timezone} format="MMM Do">
            {val}
          </Moment>
        )
      }
    },
    {
      id: "time",
      Header: <Label data="HeaderTime"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        let val = row?.date
        return (
          <Moment tz={globalProps.timezone} format="hh:mm">
            {val}
          </Moment>
        )
      }
    },
    {
      id: "number",
      Header: <Label data="HeaderCaseNum"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        return (
          row?.id
        )
      }
    },
    {
      id: "status",
      Header: <Label data="HeaderStatus"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        let val = row?.protest?.status
      return (
          <SportCode entity="@ProtestStatus" discipline="SAL" code={val}/>
        )
      }
    },
    {
      id: "event",
      Header: <Label data="HeaderEvent"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
      return (
          row?.protest?.unit?.phase?.event?.description
        )
      }
    },
    {
      id: "race",
      Header: <Label data="HeaderRace"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
      return (
          row?.protest?.unit?.shortDescription        
        )
      }
    },
    {
      id: "initiator",
      Header: <Label data="HeaderInitiator"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        return (
          row?.protest?.initiator
        )
      }
    },
    {
      id: "respondent",
      Header: <Label data="HeaderRespondent"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        let val = row?.protest?.respondent
        return (
          <Stack direction="horizontal">
            <Noc showOnlyImage={true} code={val}/> 
            <div>{val}</div>
          </Stack>
        )
      }
    },
    {
      id: "witness",
      Header: <Label data="HeaderWitness"/>,
      className: "text-start",
      Cell: (props) => {
        let row = props.cell.row.original
        return (
          row?.protest?.witness
        )
      }
    } 
  ]
)

  if (isError) { return  <NotAvailable /> }
  if (isLoading) { return <Loader /> }

  let tableData = data?.communications?.filter(c => c.type === 'PROTEST') || []

  return (
    <>
      <PageHeader title={<Label data="LabelHearingSchedule" />} />
      
      <div className='mirs-page-container'>
      <MirsTable
          id={`mirs-table-hearing-schedule`}
          data={tableData}
          columns={tableColumns}
          showLoading={false}
          initialSortBy={["date"]}
        />
      </div>
    </>
  )
}

export default HearingSchedule